import { TimelineView } from './types'

export const DEFAULT_CURRENCY = 'RUB'
export const WINDOW_MS = 24 * 60 * 60 * 1000
export const DEFAULT_STEP_MS = 60 * 60 * 1000

export const DEFAULT_VIEW: TimelineView = {
  mode: 'all',
  payoutKinds: ['rejected', 'unmatched', 'matched_unpaid', 'other'],
  payoutMerchantIds: [],
  payoutMethodIds: [],
  depositMerchantIds: [],
  depositMethodIds: [],
}
